import { notificationsMixin } from '@/mixins/notifications';
import { formatError } from '@witkac/kartamiejska-shared/dist/filters/formatError';

export const cardUseModalMixin = {
  mixins: [notificationsMixin],
  data() {
    return {
      cardUseModalMixin: {
        cardUseModal: false,
        cardNumber: undefined
      }
    };
  },
  methods: {
    // @vuese
    // Handler odczytu karty z czytnika
    // @arg `cardNumber` numer karty odczytany przy pomocy czytnika
    cardReaderHandler(cardNumber) {
      if (cardNumber) {
        this.cardUseModalMixin.cardNumber = cardNumber;
        this.$store
          .dispatch('partners/benefits/available/list', cardNumber)
          .then(() => this.showModal())
          .catch(error => this.notifyError(formatError(error)));
      }
    },
    // @vuese
    // Zamknięcie modala
    hideModal() {
      this.cardUseModalMixin.cardUseModal = false;
      this.cardUseModalMixin.cardNumber = undefined;
    },
    // @vuese
    // Otworzenie modala
    showModal() {
      this.cardUseModalMixin.cardUseModal = true;
    }
  }
};
